import { render, staticRenderFns } from "./ServiceTypeActions.vue?vue&type=template&id=63c1787a"
import script from "./ServiceTypeActions.vue?vue&type=script&lang=js"
export * from "./ServiceTypeActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports